import React from "react";
import PageShell from "@/components/PageShell";

const SECTIONS = [
    {
        title: "Acceptance",
        body: [
            "By using uknitwear.com (the “Site”) or placing an order, you agree to these Terms of Service. If you don't agree, please stop using the Site.",
            "These Terms apply alongside our Privacy Policy and Cookie Policy.",
        ],
    },
    {
        title: "The Brand",
        body: [
            "UKnitwear Ltd is registered in England & Wales (company no. 99887766) with its registered office at 19 Foundry Lane, London EC1 8KW.",
            "VAT number: GB 123 4567 89.",
        ],
    },
    {
        title: "Orders & Pricing",
        body: [
            "All prices on the Site are in USD unless otherwise displayed. Local taxes and import duties are shown at checkout where we ship DDP.",
            "An order is only confirmed when you receive an order confirmation email. We reserve the right to refuse or cancel an order for reasons including stock unavailability, pricing errors, or suspected fraud.",
            "We do not restock sold-out pieces. Drops are limited runs.",
        ],
    },
    {
        title: "Payment",
        body: [
            "We accept supported payment methods offered through Square checkout, including major cards and wallets where available.",
            "Payment is processed at the time of order. Card data is handled by Square. We never store full card details.",
        ],
    },
    {
        title: "Shipping & Delivery",
        body: [
            "We aim to dispatch within 2 business days of payment. Delivery timeframes are estimates, not guarantees.",
            "Risk passes to you upon delivery to the address you provide. If a package is marked delivered but missing, report it within 7 days and we'll lodge a claim with the courier.",
        ],
    },
    {
        title: "Returns",
        body: [
            "You have 30 days from delivery to return unworn, unwashed pieces with original tags. Sale and final-sale items are excluded.",
            "Refunds are processed within 5 business days of receipt of your return. Original shipping is non-refundable except in cases of faulty goods.",
        ],
    },
    {
        title: "Intellectual Property",
        body: [
            "The Site, all imagery, copy, garment designs, logos, and the UKnitwear name are owned by UKnitwear Ltd. You may not reproduce, repost, or commercially exploit any of it without written permission.",
            "User-submitted content (e.g. tagged social posts) may be reposted by us with credit unless you've opted out.",
        ],
    },
    {
        title: "Acceptable Use",
        body: [
            "Don't use the Site to commit fraud, scrape data, reverse-engineer our systems, or harass our team or other customers. We reserve the right to block any user violating these rules.",
        ],
    },
    {
        title: "Disclaimers & Liability",
        body: [
            "The Site is provided “as is.” We do not warrant uninterrupted availability or that the Site will be free of errors.",
            "To the maximum extent permitted by law, our total liability for any claim arising from your use of the Site or any single order is limited to the amount you paid for that order.",
            "Nothing in these Terms excludes liability for death or personal injury caused by negligence, fraud, or any other liability that cannot be excluded by law.",
        ],
    },
    {
        title: "Governing Law",
        body: [
            "These Terms are governed by the laws of England & Wales. Any dispute will be subject to the exclusive jurisdiction of the courts of England & Wales, except where consumer law in your country of residence grants you additional rights.",
        ],
    },
    {
        title: "Changes",
        body: [
            "We may update these Terms from time to time. The “last updated” date at the top tells you when. Continued use of the Site after an update means you accept the new Terms.",
        ],
    },
    {
        title: "Contact",
        body: ["Questions about these Terms: legal@uknitwear.com"],
    },
];

const Terms = () => {
    return (
        <PageShell
            kicker="[Legal / Last Updated 01.02.2026]"
            title="Terms of"
            accent="Service."
            intro="The agreement between you and UKnitwear when you use the site or place an order. We've kept it as short and clear as we legally can."
            testid="terms-page"
        >
            <section className="px-4 md:px-8 py-10 border-b-4 border-ink">
                <div className="max-w-3xl space-y-10">
                    {SECTIONS.map((s, i) => (
                        <article key={s.title} data-testid={`terms-section-${i}`}>
                            <div className="flex items-baseline gap-3">
                                <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-hazard">
                                    // {String(i + 1).padStart(2, "0")}
                                </span>
                                <h2 className="font-heading text-3xl md:text-4xl uppercase leading-none">
                                    {s.title}
                                </h2>
                            </div>
                            <ul className="mt-4 space-y-2 list-disc list-outside ml-5 text-sm md:text-base text-foreground/80 leading-relaxed">
                                {s.body.map((b, j) => (
                                    <li key={j}>{b}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>
        </PageShell>
    );
};

export default Terms;
